module.exports = __webpack_public_path__ + "static/media/asana.c020b8fb.jpg";